import { resolvePlayUrl } from "./task"

export const getDouyinVideoPlayUrl = async (
  params: API.Task.ResolvePlayUrlParams,
  signal?: AbortSignal,
) => {
  return resolvePlayUrl(params, signal)
}
